import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNumDocumento } from '../../context/AuthContext';
import { uploadProductoImage, insertProducto } from '../supabase/Productos';
import Usuario from '../supabase/Usuario';
import '../Home/Home.css';
import './Publish.css';
import logoVarita from "../Nido/varita.svg";
import logo from '../Login/logo.png';

const PROVINCIAS = [
  'San José', 'Alajuela', 'Cartago', 'Heredia', 'Guanacaste', 'Puntarenas', 'Limón'
];

const CANTONES = {
  'San José': ['San José','Escazú','Desamparados','Puriscal','Tarrazú','Aserrí','Mora','Goicoechea','Santa Ana','Alajuelita','Vásquez de Coronado','Acosta','Tibás','Moravia','Montes de Oca','Turrubares','Dota','Curridabat','Pérez Zeledón','León Cortés'],
  'Alajuela': ['Alajuela','San Ramón','Grecia','San Mateo','Atenas','Naranjo','Palmares','Poás','Orotina','San Carlos','Zarcero','Valverde Vega','Upala','Los Chiles','Guatuso','Río Cuarto'],
  'Cartago': ['Cartago','Paraíso','La Unión','Jiménez','Turrialba','Alvarado','Oreamuno','El Guarco'],
  'Heredia': ['Heredia','Barva','Santo Domingo','Santa Bárbara','San Rafael','San Isidro','Belén','Flores','San Pablo','Sarapiquí'],
  'Guanacaste': ['Liberia','Nicoya','Santa Cruz','Bagaces','Carrillo','Cañas','Abangares','Tilarán','Nandayure','La Cruz','Hojancha'],
  'Puntarenas': ['Puntarenas','Esparza','Buenos Aires','Montes de Oro','Osa','Quepos','Golfito','Coto Brus','Parrita','Corredores','Garabito'],
  'Limón': ['Limón','Pococí','Siquirres','Talamanca','Matina','Guácimo']
};

export default function Publish() {
  const navigate = useNavigate();
  const numDocumento = useNumDocumento();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [titulo, setTitulo] = useState('');
  const [precio, setPrecio] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [categoria, setCategoria] = useState('Producto');
  const [idTipoEntrega, setIdTipoEntrega] = useState('1');
  const [provincia, setProvincia] = useState('');
  const [canton, setCanton] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const cantones = useMemo(() => (CANTONES[provincia] || []), [provincia]);

  const onSelectFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 3 * 1024 * 1024) {
      setError('La imagen supera los 3MB permitidos.');
      return;
    }
    setError('');
    setFile(f);
    const url = URL.createObjectURL(f);
    setPreview(url);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    // Validaciones
    if (!file) return setError('Sube una imagen (máx 3MB).');
    if (!titulo.trim()) return setError('Ingresa el título.');
  const precioNum = Number(precio);
  if (!Number.isFinite(precioNum) || precioNum <= 0 || precioNum > 9999999) return setError('Precio inválido (1 a 9,999,999).');
    if (!provincia) return setError('Selecciona una provincia.');
    if (!canton) return setError('Selecciona un cantón.');
    if (!numDocumento) return setError('Sesión inválida.');

    setSubmitting(true);
    try {
      const up = await uploadProductoImage(file, { ownerNumDocumento: numDocumento });
      if (up.error || !up.path) {
        console.error('[Publish] upload error:', up.error);
        setError('No se pudo subir la imagen.');
        setSubmitting(false);
        return;
      }

      const nowIso = new Date().toISOString();
      const direccion = `${provincia}, ${canton}`;
      const row = {
        docUsuario: numDocumento,
        categoria,
        titulo: titulo.trim(),
        descripcion: descripcion.trim(),
        precio: precioNum,
        direccion,
        idTipoEntrega: Number(idTipoEntrega),
        fecha: nowIso,
        idEstado: 1,
        rutaImagen: up.path,
      };
      const { id, error: insErr } = await insertProducto(row);
      if (insErr || !id) {
        console.error('[Publish] insert error:', insErr);
        setError('No se pudo publicar el producto.');
        setSubmitting(false);
        return;
      }

      // Bonus de varitas aleatorio (5 a 15), este rango se puso por ejemplo
      try {
        const bonus = Math.floor(Math.random() * (15 - 5 + 1)) + 5;
        const ok = await Usuario.agregarVaritas(numDocumento, bonus);
        if (!ok) console.warn('[Publish] no se pudo acreditar varitas de bonus');
      } catch (e) {
        console.warn('[Publish] excepción acreditando varitas de bonus:', e);
      }

      navigate('/home');
    } catch (err) {
      console.error('[Publish] excepción:', err);
      setError('Ocurrió un error al publicar.');
    } finally {
      setSubmitting(false);
    }
  };

  const onBack = () => navigate('/home');

  return (
    <div className="app-container">
      <header className="topbar" role="banner">
        <div className="brand">
          <img src={logo} alt="Logo reANIDArt - Muestra 1 pájaro con dos polluelos en un nido de ramas con hojas alrededor" className="brand-logo" onClick={() => navigate('/home')} />
          <nav className="nav" aria-label="navegación principal">
            <button className="nav-link active" onClick={() => navigate('/home')}>Inicio</button>
            <button className="nav-link" onClick={() => navigate('/profile')}>Mi nido</button>
          </nav>
        </div>
        <div className="right" />
          <title>ReANIDArt - Publicar</title>
      </header>

      <main className="content" style={{ maxWidth: 900 }} role="main">
        <form onSubmit={onSubmit} aria-label="Formulario de publicación" style={{ background:'#fff3c4', border:'1px solid #f5e6a7', borderRadius:12, padding:16 }}>
          <h2 style={{ marginTop:0 }}>Imagen</h2>
          <div className="publish-image-row">
            <label htmlFor="image" className="publish-image-drop">
              {preview ? (
                <img src={preview} alt="preview" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:10 }} />
              ) : (
                <span style={{ fontSize:28, color:'#666' }} aria-hidden>+</span>
              )}
            </label>
            <input id="image" type="file" accept="image/*,.bmp,.dib" onChange={onSelectFile} style={{ display:'none' }} />
          </div>

          <div style={{ display:'grid', gap:12 }}>
            <div>
              <label htmlFor="titulo" style={{ fontWeight:700 }}>Título</label>
              <input id="titulo" value={titulo} onChange={(e)=>setTitulo(e.target.value)} placeholder="Título" required aria-required="true" style={{ width:'100%', height:36, borderRadius:8, border:'1px solid #ccc', padding:'0 10px' }} />
            </div>
            <div>
              <label htmlFor="precio" style={{ fontWeight:700 }}>Precio</label>
              <input id="precio" type="number" value={precio} onChange={(e)=>setPrecio(e.target.value)} placeholder="Precio" min={1} max={9999999} step={1} required aria-required="true" style={{ width:'100%', height:36, borderRadius:8, border:'1px solid #ccc', padding:'0 10px' }} />
            </div>
            <div>
              <label htmlFor="descripcion" style={{ fontWeight:700 }}>Descripción</label>
              <textarea
                id="descripcion"
                value={descripcion}
                onChange={(e)=>setDescripcion(e.target.value)}
                placeholder="Descripción (opcional)"
                rows={3}
                style={{ width:'100%', borderRadius:8, border:'1px solid #ccc', padding:'8px 10px', fontFamily:'inherit', fontSize:16 }}
              />
            </div>

            <div>
              <label htmlFor="categoria" style={{ fontWeight:700 }}>Categoría</label>
              <select id="categoria" value={categoria} onChange={(e)=>setCategoria(e.target.value)} style={{ width:'100%', height:36, borderRadius:8, border:'1px solid #ccc', padding:'0 10px' }}>
                <option value="Producto">Producto</option>
                <option value="Servicio">Servicio</option>
              </select>
            </div>
            <div>
              <label htmlFor="tipoEntrega" style={{ fontWeight:700 }}>Tipo de entrega</label>
              <select id="tipoEntrega" value={idTipoEntrega} onChange={(e)=>setIdTipoEntrega(e.target.value)} style={{ width:'100%', height:36, borderRadius:8, border:'1px solid #ccc', padding:'0 10px' }}>
                <option value="1">Entrega en persona</option>
                <option value="2">Envío</option>
              </select>
            </div>

            <div>
              <label style={{ fontWeight:700 }}>Ubicación</label>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                <select id="provincia" value={provincia} onChange={(e)=>{ setProvincia(e.target.value); setCanton(''); }} required aria-required="true" style={{ flex:'1 1 240px', height:36, borderRadius:8, border:'1px solid #ccc', padding:'0 10px' }}>
                  <option value="">Provincia</option>
                  {PROVINCIAS.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
                <select id="canton" value={canton} onChange={(e)=>setCanton(e.target.value)} disabled={!provincia} required aria-required="true" style={{ flex:'1 1 240px', height:36, borderRadius:8, border:'1px solid #ccc', padding:'0 10px' }}>
                  <option value="">Cantón</option>
                  {cantones.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>
          </div>

          {error && <div className="error" role="alert" aria-live="assertive" style={{ marginTop:10 }}>{error}</div>}

          <div style={{ display:'flex', gap:16, justifyContent:'center', marginTop:20 }}>
            <button type="button" className="vp-btn" onClick={onBack} disabled={submitting}>Volver</button>
            <button type="submit" className="vp-btn primary" disabled={submitting}>{submitting ? 'Publicando...' : 'Publicar'}</button>
          </div>

          <div style={{ textAlign:'right', marginTop:10, color:'#1f2937', fontWeight:700 }}>¡publica y obtén {<img src={logoVarita} alt="varita" style={{ width: 20, height: 20 }} />} de inmediato!</div>
        </form>
      </main>
    </div>
  );
}
